<section class="parker-banner">
  <app-mini-env-banner class="ars-banner-section" [slides]="bannerSlides" (butonAction)="onSliderBtnAction($event)"></app-mini-env-banner>
  
</section>
<section class="container-fluid discount-section">
  <div class="container">
    <app-mini-env-heading-block class="discount" [miniTitle]="'Benefits Overview'"
      [title]="'Up to 80% discount on your healthcare needs!'"
      [description]="'WoW Health is a single door to access all type of healthcare providers. We are your next neighborhood.'"
      [style]="'max-width: 703px;'" [discription]="'max-width: 541px;'"></app-mini-env-heading-block>

    <app-mini-env-benefit-cards [services]="services"></app-mini-env-benefit-cards>

  </div>
</section>

<section class="container-fluid talking-section">
  <div class="container">

    <app-mini-env-heading-block [miniTitle]="'Why Choose Us?'" [title]="'Because taking care of yourself should feel easy'"
      [description]="'Healthcare shouldn’t slow you down or add stress to your day. We remove the friction with simple access, clear guidance, and care that fits seamlessly into your routine.'"
      [style]="'max-width: 665px;'"></app-mini-env-heading-block>

    <div class="row" style="row-gap: 15px;margin-top: 30px;gap: 15px;">
      <div *ngFor="let item of benefits" class="card-box col-12">
        <app-mini-env-tall-info-card [title]="item.title" [description]="item.description" [bgImage]="item.bgImage">
        </app-mini-env-tall-info-card>
      </div>
    </div>
  </div>
</section>

<section class="container-fluid services-section">
  <div class="container">

    <app-mini-env-heading-block [miniTitle]="'Services'" [title]="'Premium Care, Unmatched Savings'"
      [description]="'Your healthcare gets super easy and accessible when it is at your fingertips, no long waits or queue hassles.'"
      [style]="'max-width: 684px;'"></app-mini-env-heading-block>

    <div class="responsive-tabs mt-20">

      <div class="tab-body ars-service-section">
        <app-mini-env-content-box [imgSrc]="imgSrc" class="custome-box">
          <h2 class="content-heading">{{ ('BANNER.TITLE' | translateIt: {language: sharedService.currentLanguage} | async) }}</h2>
          <p class="content-txt">
            {{ ('BANNER.DESCRIPTION' | translateIt: {language: sharedService.currentLanguage} | async) }}
          </p>

          <ul class="d-flex content-list">
            <li class="bullet">
              <div>
                <img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
              </div>
              <div>
                <span class="bullet-heading">{{ ("BANNER['strong-1']" | translateIt: {language: sharedService.currentLanguage} | async) }}: </span>
                <span>
                  {{ ('BANNER.li1' | translateIt: {language: sharedService.currentLanguage} | async) }}
                </span>
              </div>
            </li>
            <li class="bullet">
              <div>
                <img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
              </div>
              <div>
                <span class="bullet-heading">{{ ("BANNER['strong-2']" | translateIt: {language: sharedService.currentLanguage} | async) }}</span>
                <span>
                  {{ ('BANNER.li2' | translateIt: {language: sharedService.currentLanguage} | async) }}
                </span>
              </div>
            </li>
            <li class="bullet">
              <div>
                <img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
              </div>
              <div>
                <span class="bullet-heading">{{ ("BANNER['strong-3']" | translateIt: {language: sharedService.currentLanguage} | async) }} </span>
                <span>
                   {{ ('BANNER.li3' | translateIt: {language: sharedService.currentLanguage} | async) }}
                </span>
              </div>
            </li>
              <li class="bullet">
              <div>
                <img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
              </div>
              <div>
                <span class="bullet-heading">{{ ("BANNER['strong-4']" | translateIt: {language: sharedService.currentLanguage} | async) }} </span>
                <span>
                  {{ ("BANNER[' li4']" | translateIt: {language: sharedService.currentLanguage} | async) }}
                </span>
              </div>
            </li>
          </ul>
        </app-mini-env-content-box>
      </div>

    </div>
  </div>
</section>
<section class="container-fluid login-section">
  <app-mini-env-heading-block  [title]="'Start Your Health Transformation Today'"
    [description]="'Don’t wait another moment to take control of your health. Access personalized, convenient, and affordable healthcare solutions right at your fingertips.'"
    [style]="'max-width: 749px;'"></app-mini-env-heading-block>
    <button (click)="login()" class="login-btn-redirect">Get Started Now</button>
</section>


<section class="container-fluid faq-section">
  <div class="container">

    <app-mini-env-heading-block [miniTitle]="'FAQs'" [title]="'Frequently Asked Questions'"
      [description]="'Some questions you might have in your mind. If you couldnt find yours, call us anytime at 844-969-4325'"
      [style]="'max-width: 496px;'"></app-mini-env-heading-block>

    <div class="mt-30">
      <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
    </div>
  </div>
</section>

<!--  How can we help Section End-->